import React from 'react';
import { FileText } from 'lucide-react';

export default function MetaHero() {
  const scrollToGenerator = () => {
    document.getElementById('meta-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="SEO optimization workspace"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900 via-emerald-800 to-emerald-900 opacity-85"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <FileText className="w-16 h-16 text-emerald-400 animate-pulse" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Meta Title Generator
        </h1>
        <p className="text-xl text-emerald-100 mb-8 max-w-3xl mx-auto">
          Create SEO-optimized meta titles for your web pages with our AI-powered tool.
          Perfect for blogs, e-commerce, and business websites.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-emerald-700/50 px-4 py-2 rounded-full text-white text-sm border border-emerald-500/30">
            SEO Optimized
          </span>
          <span className="bg-emerald-700/50 px-4 py-2 rounded-full text-white text-sm border border-emerald-500/30">
            Character Count
          </span>
          <span className="bg-emerald-700/50 px-4 py-2 rounded-full text-white text-sm border border-emerald-500/30">
            Keyword Focus
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-emerald-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-emerald-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <FileText className="w-5 h-5" />
          Generate Meta Titles
        </button>
        <p className="mt-6 text-sm text-emerald-200 bg-emerald-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Trusted by over 50,000+ websites worldwide
        </p>
      </div>
    </div>
  );
}